/**
 * @generated SignedSource<<f5728a564734d92b874d58feb4d57efb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobilePageHeader_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerIncentives_viewer">;
  readonly " $fragmentType": "CheckoutMobilePageHeader_viewer";
};
export type CheckoutMobilePageHeader_viewer$key = {
  readonly " $data"?: CheckoutMobilePageHeader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobilePageHeader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobilePageHeader_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerIncentives_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f46d6ea05470f66b953f6867fc61c5cf";

export default node;
